import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const ShortBalanceChart = ({ data }) => {
  const [mainTabination, setMainTabination] = useState(1);

  // Dummy data for testing
  // const dummyData = {
  //   balance: [1000, 1050, 1030, 1070, 1100, 1150, 1200, 1180, 1220, 1250],
  //   trades: [5, 10, 8, 15, 12, 18, 20, 17, 19, 21],
  // };

  const [Series, setSeries] = useState([
    {
      name: "Balance",
      type: "area",
      data: data && data?.balance,
    },
  ]);

  const [Options, setOptions] = useState({
    colors: ["#0D56EB"],
    fill: {
      colors: "#0D56EB",
      type: "gradient",
      gradient: {
        type: "vertical",
        shadeIntensity: 0,
        gradientToColors: undefined,
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 90, 100],
      },
    },
    legend: {
      fontSize: "14px",
      fontWeight: 700,
      labels: {
        colors: "white",
      },
      markers: {
        width: 15,
        height: 15,
      },
    },
    chart: {
      fontFamily: "Outfit, sans-serif",
      toolbar: {
        show: false,
      },
      type: "area",
      zoom: {
        enabled: false,
      },
      animations: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 4,
    },
    grid: {
      borderColor: "#393939",
      strokeDashArray: 0,
    },
    labels: Array.from({ length: data?.balance.length }, (_, i) => i + 1),
    xaxis: {
      type: "numeric",
      tickPlacement: "on",
      tickAmount: data?.balance.length, // Ensures that every point is labeled
      tooltip: {
        enabled: false,
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        style: {
          colors: "#8B8E93",
          fontSize: "12px",
        },
        formatter: (val) => Math.round(val),
      },
    },
    yaxis: [
      {
        type: "numeric",
        labels: {
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },
    ],
    tooltip: {
      enabled: true,
      style: {
        fontSize: "14px",
        fontWeight: "700",
      },
      x: {
        show: true,
        formatter: (val) => `Point ${Math.round(val)}`,
      },
    },
  });

  useEffect(() => {
    if (mainTabination === 1) {
      setSeries([
        {
          name: "Balance",
          type: "area",
          data: data && data?.balance,
        },
      ]);
    } else if (mainTabination === 2) {
      setSeries([
        {
          name: "No. of Trades",
          type: "area",
          data: data && data?.number_of_trades,
        },
      ]);
    }
  }, [mainTabination]);

  return (
    <div id="chart">
      <div className="chart_tabination">
        <button
          onClick={() => {
            setMainTabination(1);
          }}
          className={
            "chart_tabination_item " + (mainTabination === 1 && " active ")
          }
        >
          Balance
        </button>

        <button
          onClick={() => {
            setMainTabination(2);
          }}
          className={
            "chart_tabination_item " + (mainTabination === 2 && " active ")
          }
        >
          No. of trades
        </button>
      </div>

      {mainTabination === 1 && (
        <div className="left_chart">
          <ReactApexChart options={Options} series={Series} height={240} />
        </div>
      )}
      {mainTabination === 2 && (
        <div className="right_chart">
          <ReactApexChart options={Options} series={Series} height={240} />
        </div>
      )}
    </div>
  );
};

export default ShortBalanceChart;
